export const ACTIVE = 'ACTIVE'
export const INVITED = 'INVITED'
export const LOCKED = 'LOCKED'
export const RESET = 'RESET'
